import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { ReactSortable } from "react-sortablejs";
import { getPaymentMethodSagaAction, removePaymentMethodSagaAction, sortSagaAction } from "../../redux/sagaActions";

const PaymentMethods = () => {
    const dispatch = useDispatch();
    const payment_methods = useSelector(state => state.payment_methods);

    const [list, setList] = useState([]);

    // Смена позиций
    const changePositions = ({ oldInd, newInd }) => {
        // Копируем начальный массив
        let copy = [...payment_methods];

        let cut = copy.splice(oldInd, 1)[0];
        copy.splice(newInd, 0, cut);

        dispatch(sortSagaAction({
            table: 'payment_methods',
            new_order: JSON.stringify(copy.map(elem => elem.id))
        }));

        setList([]);
    };

    return (
        <div className="settings">
            <ReactSortable
                list={ list }
                setList={ setList }
                handle={ '.control--move' }
                onEnd={ event => changePositions({ oldInd: event.oldIndex, newInd: event.newIndex }) }
            >
                {
                    payment_methods.map(elem => {
                        return (
                            <div className="setting" key={ elem.id }>
                                <div className="controls">
                                    <i className="control control--edit" onClick={ () => {
                                        dispatch(getPaymentMethodSagaAction({ id: elem.id }));
                                    } }/>
                                    <i className="control control--move" />
                                    <i className="control control--remove" onClick={ () => {
                                        if (window.confirm('Вы действительно хотите удалить этот тип оплаты?')) {
                                            dispatch(removePaymentMethodSagaAction({ id: elem.id }));
                                        }
                                    } }/>
                                </div>
                                <div className="setting__caption">{ elem.name }</div>
                                <div className="setting__info-wrapper">
                                    {
                                        elem.active === '0' && <div className="setting__info setting__info--inactive">Неактивен</div>
                                    }
                                </div>
                            </div>
                        );
                    })
                }
            </ReactSortable>
        </div>
    );
};

export default PaymentMethods;

